import React, { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import "./Blog.scss";
import BlogCard from "../../components/blogCard/BlogCard";
import { blogSection } from "../../portfolio";
import { Fade } from "react-reveal";
import StyleContext from "../../contexts/StyleContext";
import ReactMarkdown from "react-markdown";

export default function Blogs() {
  const { isDark } = useContext(StyleContext);
  const [mediumBlogs, setMediumBlogs] = useState([]);
  const [markdownContent, setMarkdownContent] = useState({});

  function setMediumBlogsFunction(array) {
    setMediumBlogs(array);
  }

  function extractTextContent(html) {
    return typeof html === "string"
      ? html
          .split(/<\/p>/i)
          .map((part) => part.split(/<p[^>]*>/i).pop())
          .filter((el) => el.trim().length > 0)
          .map((el) => el.replace(/<\/?[^>]+(>|$)/g, "").trim())
          .join(" ")
      : NaN;
  }

  useEffect(() => {
    const loadMarkdownFiles = async () => {
      const content = {};
      for (const blog of blogSection.blogs) {
        if (blog.url.startsWith("/blogsmd/")) {
          try {
            const response = await fetch(`./${blog.url.slice(1)}`);
            if (response.ok) {
              content[blog.url] = await response.text();
            } else {
              console.error(`Fetch failed for ${blog.url}: ${response.status}`);
            }
          } catch (error) {
            console.error(`Failed to load ${blog.url}: ${error}`);
            content[blog.url] = `Error loading ${blog.url}`;
          }
        }
      }
      console.log("Markdown Content:", content);
      setMarkdownContent(content);
    };

    if (blogSection.displayMediumBlogs === "true") {
      const getProfileData = () => {
        fetch("/blogs.json")
          .then((result) => (result.ok ? result.json() : null))
          .then((response) => {
            if (response) setMediumBlogsFunction(response.items);
          })
          .catch((error) => {
            console.error(
              `${error} (because of this error Blogs section could not be displayed. Blogs section has reverted to default)`
            );
            setMediumBlogsFunction("Error");
            blogSection.displayMediumBlogs = "false";
          });
      };
      getProfileData();
    }

    loadMarkdownFiles();
  }, []);

  if (!blogSection.display) {
    return null;
  }

  return (
    <Fade bottom duration={1000} distance="20px">
      <div className="main" id="blogs">
        <div className="blog-header">
          <h1 className="blog-header-text">{blogSection.title}</h1>
          <p
            className={
              isDark ? "dark-mode blog-subtitle" : "subTitle blog-subtitle"
            }
          >
            {blogSection.subtitle}
          </p>
        </div>
        <div className="blog-main-div">
          <div className="blog-text-div">
            {blogSection.displayMediumBlogs !== "true" ||
            mediumBlogs === "Error"
              ? blogSection.blogs.map((blog, i) => (
                  <Link
                    key={i}
                    to={`/blogs/${blog.url.split("/").pop().replace(".md", "")}`}
                    style={{ textDecoration: "none" }}
                  >
                    <BlogCard
                      isDark={isDark}
                      blog={{
                        url: blog.url,
                        image: blog.image,
                        title: blog.title,
                        description:
                          blog.url.startsWith("/blogsmd/")
                            ? markdownContent[blog.url]?.split("\n")[0] || "Loading..."
                            : blog.description,
                        content: null // Content not displayed in card
                      }}
                    />
                  </Link>
                ))
              : mediumBlogs.map((blog, i) => (
                  <BlogCard
                    key={i}
                    isDark={isDark}
                    blog={{
                      url: blog.link,
                      title: blog.title,
                      description: extractTextContent(blog.content)
                    }}
                  />
                ))}
          </div>
        </div>
      </div>
    </Fade>
  );
}